import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ui-empty-image',
    standalone: true,
    template: `
    <div class="w-full h-full flex items-center justify-center bg-[#fff5f7] text-rose-200" [class.rounded-inherit]="true">
      <svg [attr.class]="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 7a2 2 0 012-2h3l2-2h4l2 2h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
        <circle cx="12" cy="13" r="3.2" />
      </svg>
    </div>
    `
})
export class UiEmptyImageComponent {
    @Input() iconClass = 'w-7 h-7';
}
